import { put } from "@redux-saga/core/effects";
import { toast } from "react-toastify";
import { SettingsApi } from "../../../generated/api/apis/SettingsApi";
import i18n from "../../../i18n/i18n";
import { getAPIConfig } from "../../../util/api-config";
import { handleError } from "../../../util/errorHandler";
import store from "../../configureStore";
import {
  GET_SFTP_SETTINGS,
  setSettings,
  setSftpNames,
  setSftpSettings,
} from "../../reducers/componentReducer";
import { requestGetSettings } from "../requests/settingsRequest";

function setUpClient() {
  return new SettingsApi(
    getAPIConfig(store.getState().settings.internalSettings)
  );
}

export function* handleGetSettings(): any {
  try {
    const response = yield requestGetSettings();
    yield put(setSettings(response.data));
  } catch (error: any) {
    yield handleError(error);
  }
}

export function* handleGetSftpNames(): any {
  try {
    const SettingsClient = setUpClient();
    const response = yield SettingsClient.getSftpNames();
    yield put(setSftpNames(response));
  } catch (error: any) {
    yield handleError(error);
  }
}

export function* handleGetSftpSettings(): any {
  try {
    const SettingsClient = setUpClient();
    const response = yield SettingsClient.getSftpSettings();
    yield put(setSftpSettings(response));
  } catch (error: any) {
    yield handleError(error);
  }
}

export function* handlePutSftpSettings(action: any): any {
  try {
    const SettingsClient = setUpClient();
    yield SettingsClient.saveSftpSetting(action.settingsDto);
    toast.success(String(i18n.t("toasts.sftpSaved")));
    yield put({ type: GET_SFTP_SETTINGS });
  } catch (error: any) {
    yield handleError(error);
  }
}
